import {Observable} from 'rxjs/Observable';
import FileStackClient from 'utils/filestack';

export function doImageMetadata(observer, file, options) {
    FileStackClient.metadata(file.handle, options).then((response) => {
        try {
            observer.next(response);
        } catch (err) {
            observer.error(err);
        }
    }).catch(err => observer.error(err));
}

export function imageMetadata(options) {
    return (source) => {
        return new Observable((observer) => {
            return source.subscribe({
                    next(file) {
                        doImageMetadata(observer, file, options);
                    },
                    error(err) {
                        observer.error(err);
                    },
                    complete() {
                        observer.complete();
                    }
                }
            );
        })
    }
}


// WEBPACK FOOTER //
// ./public/observables/lettables/imageMetadata.js